import { request } from '@/shared/api/request'
export const downloadTransfer = (period, bin) =>
	request({
		url: '/contract/universalMethods/transfert/download?bin=' + bin + '&period=' + period,
		method: 'GET',
		responseType: 'blob',
	})
